import apiService from '@/services/apiService';

const actions = {
  getOurServiceBanner({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('our-service-banner/find-one')
        .then((response) => {
          commit('getOurServiceBanner', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postOurServiceBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('our-service-banner/insert-or-update', payload)
        .then((response) => {
          // commit('postAboutUsBanner', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
